export default __webpack_public_path__ + "static/media/case-study-6-type-31.5f4223b0.mp4";